// Docs:

// {{{ Docs.Chooser

GW.define('Docs.Chooser', 'Main.Screen', {
	title: _('Dokumentace'),
	titleIcon: 'bookopen',

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
				nodeName: 'img',
				src: APP_BASE + 'img/thesis-pana.svg',
				className: 'illustration',
				width: 295,
				height: 295,
			}, {
				children: [{
					nodeName: 'h1',
					className: 'title',
					textContent: _('Dokumentace pro aplikaci\nBC4 Kontaktní centrum'),
				}, {
					className: 'docs-container',
					children: [{
						nodeName: 'a',
						href: APP_BASE + 'docs/user',
						className: 'button secondary large icon-left',
						children: [Utils.useIcon('headphones'), _('Uživatelská příručka') ],
					}, {
						nodeName: 'a',
						href: APP_BASE + 'docs/admin',
						className: 'button secondary large icon-left',
						children: [Utils.useIcon('settings'), _('Administrátorská příručka') ],
					}]
				}]
		}], this);
	},
});

// }}}
// {{{ Docs.Reader

GW.define('Docs.Reader', 'Main.Screen', {
	title: _('Dokumentace'),
	titleIcon: 'bookopen',

	'after:initComponent'() {
		this.bodyEl.gwReplaceChildren([{
			ref: 'contentEl',
			'on:scroll': ev => this.selectTocMenuItem(),
		}], this);

		this.sidebarEl.gwCreateChild({
			ref: 'menuEl',
			className: 'vertical-menu',
		}, this);
	},

	selectTocMenuItem() {
		/*
		 * Menu item is activated for the last scrolled off heading
		 * that has link in the toc menu.
		 */
		let ct_pos = this.contentEl.getBoundingClientRect();
		let selected = this.menuEl.children[0];
		for (let c of this.menuEl.children) {
			let h_pos = c.$heading.getBoundingClientRect();
			if (h_pos.top - 40 > ct_pos.top) {
				break;
			}

			selected = c;
		}

		Utils.selectListItem(this.menuEl, '.item', 'active', i => i === selected);
	},

	renderContent(md, sizes) {
		let img_prefix = `${APP_BASE}docs/${encodeURIComponent(this.doc)}/${encodeURIComponent(this.docLang)}/`;
		let parser = new DOMParser;
		let contentDoc = parser.parseFromString(marked.parse(md), 'text/html');

		contentDoc.querySelectorAll('img').forEach(img => {
			let src = img.getAttribute('src');
			img.removeAttribute('src');
			let size = sizes.get(src);
			if (size) {
				img.style.height = 'auto';
				img.width = size[0] / 2;
				img.height = size[1] / 2;
			}

			img.loading = 'lazy';
			img.src = img_prefix + src;
		});

		/*
		 * IDs must be unique across the whole DOM, improve the chances
		 * by removing all id's from parsed document and only add ids
		 * where we need them, prefixed with 'doc-toc-'
		 */
		contentDoc.querySelectorAll('[id]').forEach(el => {
			el.removeAttribute('id');
		});

		this.contentEl.style.textAlign = '';
		this.contentEl.classList.add('panel-container');
		this.contentEl.textContent = '';
		for (let c of Array.from(contentDoc.body.children)) {
			this.contentEl.appendChild(c);
		}
		this.menuEl.textContent = '';

		for (let h2 of this.contentEl.querySelectorAll('h2')) {
			let title = h2.textContent.trim();
			let slug = 'doc-toc-' + TextUtils.unaccent(title.replace(/\s/g, '-').toLowerCase());
			let icon = Array.from(h2.childNodes).filter(n => n instanceof Comment)
				.map(n => n.textContent.trim()).join('') || 'report';

			h2.id = slug;
			h2.$menuItemEl = this.menuEl.gwCreateChild({
				$heading: h2,
				nodeName: 'a',
				className: 'item',
				href: '#' + slug,
				children: [Utils.useIcon(icon), title],
			});
		}

		this.sidebarEl.classList.remove('hidden');
		this.selectTocMenuItem();
	},

	renderNotFound() {
		this.menuEl.textContent = '';
		this.sidebarEl.classList.add('hidden');

		this.contentEl.textContent = _('Dokumentace nebyla nenalezena.');
		this.contentEl.style.textAlign = 'center';
	},

	scrollToSelectedItem(useOffset) {
		let targetHeading = document.getElementById(location.hash.replace('#', ''));
		if (targetHeading) {
			targetHeading.scrollIntoView({block: "start"});
			if (useOffset) {
				this.contentEl.scrollTop -= 30;
			}
		}
	},

	async loadDoc(doc) {
		if (this.doc == doc) {
			this.scrollToSelectedItem();
			return;
		}

		this.doc = doc;

		// append newly supproted docs here
		let supported_langs = ['cs'];

		this.docLang = supported_langs.find(l => l == i18n.lang) || supported_langs[0];

                // Load data

		let md;
		let docs_prefix = APP_BASE + `docs/${encodeURIComponent(doc)}/${encodeURIComponent(this.docLang)}`;

		try {
			let response = await fetch(`${docs_prefix}/index.md`);
			if (!response.ok) {
				this.renderNotFound();
				return;
			}

			md = await response.text();
		} catch (ex) {
			this.renderNotFound();
			return;
		}

		let sizes = new Map;
		try {
			let size_data = await REST.GET(docs_prefix + '/images/sizes.json');

			sizes = new Map(Object.entries(size_data).map(e => ['images/' + e[0], e[1]]));
		} catch (ex) {
		}

		// Doc group title
		
		let docTitle = {
			user: _('Uživatelská příručka'),
			admin: _('Administrátorská příručka')
		}[doc] || '';

		this.titleEl.onclick = (e) => {
			if (e.currentTarget === e.target) {
				Application.pushRoute(APP_BASE + 'docs');
			}
		}

		this.titleEl.gwCreateChild({
			className: 'subtitle',
			children: [Utils.useIcon('arrow-simple-right'), {
				textContent: docTitle,
				'on:click': e => {
					if (this.contentEl.scrollTop > 0) {
						// Just scroll to top
						this.contentEl.scrollTo({ top: 0, behavior: 'smooth'});
					} else {
						// When we're already scrolled on top, just animate bump
						this.contentEl.scrollTo({ top: 20, behavior: 'smooth'});
						for (var i=1; i <= 3; i++) { bumpScroll(i, this.contentEl); }
						function bumpScroll(i, el) {
							setTimeout(()=>{
								el.scrollTo({ top: ( i % 2 === 0 ? 5 : 0 ), behavior: 'smooth'});
							}, i * 100);	
						}
					}
				},
			}],
		});

                // Content

		this.renderContent(md, sizes);

                // Scroll to specific heading on initial load

		this.scrollToSelectedItem(true);
		this.contentEl.classList.add('scroll-smooth');
	},
});

// }}}
// {{{ Routes

Application.addRoutes([{
	group: 'auth',
	path: APP_BASE + 'docs/{id:str}',
	async handler({params, captures}) {
		let c = Application.show({
			xtype: 'Docs.Reader',
			id: 'docs',
		});

		c.loadDoc(captures.id);
	}
}, {
	group: 'auth',
	path: APP_BASE + 'docs',
	async handler() {
		Application.show({
			xtype: 'Docs.Chooser',
		});
	}
}]);

// }}}
